export const jobFunctions = [
    "Administration",
    "Human Resources",
    "Finance and Accounting",
    "Marketing",
    "Sales",
    "Customer Service",
    "Information Technology",
    "Engineering",
    "Operations",
    "Project Management",
    "Healthcare",
    "Education",
    "Legal",
    "Research and Development",
    "Creative and Design",
    "Hospitality",
    "Real Estate",
    "Manufacturing"
]


export const jobIndustries = [
    "Healthcare",
    "Technology",
    "Finance",
    "Education",
    "Retail",
    "Manufacturing",
    "Construction",
    "Hospitality",
    "Transportation and Logistics",
    "Real Estate",
    "Legal",
    "Energy",
    "Telecommunications",
    "Media and Entertainment",
    "Agriculture",
    "Government",
    "Non-Profit",
    "Aerospace"
]


export const workTypes = [
    "Full-Time",
    "Part-Time",
    "Contract",
    "Temporary",
    "Internship",
    "Freelance",
    "Remote",
    "On-Site",
    "Hybrid"
]

export const nigeriaStates = [
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "FCT (Federal Capital Territory)",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara"
]

export const minimumRequirements = [

    "High School Diploma",
    "Associate Degree",
    "Bachelor's Degree",
    "Master's Degree",
    "Higher National Diploma",
    "National Diploma",
    "Doctorate Degree",
    "Relevant Certifications",
    "Work Experience",
    "Professional Licenses",
    "Technical Skills",
    "Language Proficiency",
    "Security Clearance",
    "Portfolio of Work",
    "References",
    "Physical Ability",
    "Driver's License",
    "SSCE",
    "others"
]


export const experienceLengths = [
    "No Experience",
    "1-2 Years",
    "3-5 Years",
    "6-8 Years",
    "9-11 Years",
    "12-15 Years",
    "16+ Years"
]

export const jobLevels = [
    "Entry Level",
    "Mid Level",
    "Senior Level",
    "Executive Level",
    "Internship",
    "Contract",
    "Freelance"
]

export const currencies = [
    "USD - United States Dollar",
    "EUR - Euro",
    "GBP - British Pound Sterling",
    "JPY - Japanese Yen",
    "CNY - Chinese Yuan",
    "AUD - Australian Dollar",
    "CAD - Canadian Dollar",
    "CHF - Swiss Franc",
    "INR - Indian Rupee",
    "SGD - Singapore Dollar",
    "NGN - Nigerian Naira",
    "NZD - New Zealand Dollar",
    "HKD - Hong Kong Dollar",
    "SEK - Swedish Krona",
    "KRW - South Korean Won",
    "AED - United Arab Emirates Dirham",
    "BRL - Brazilian Real",
    "RUB - Russian Ruble",
    "ZAR - South African Rand",
    "MXN - Mexican Peso"
]

export const jobSkills = [
    "Communication",
    "Teamwork",
    "Problem-Solving",
    "Time Management",
    "Leadership",
    "Adaptability",
    "Critical Thinking",
    "Project Management",
    "Technical Skills",
    "Customer Service",
    "Creativity",
    "Data Analysis",
    "Negotiation",
    "Sales",
    "Marketing",
    "Research",
    "Financial Analysis",
    "IT Skills",
    "Programming",
    "Networking",
    "Public Speaking",
    "Writing",
    "Design",
    "Conflict Resolution",
    "Multitasking",
    "Attention to Detail",
    "Foreign Languages",
    "Strategic Planning",
    "Decision Making",
    "Empathy",
    "Emotional Intelligence",
    "Interpersonal Skills",
    "Presentation Skills",
    "Microsoft Office",
    "SQL",
    "SEO",
    "Social Media",
    "Content Creation",
    "Copywriting",
    "Editing",
    "Quality Assurance",
    "Risk Management",
    "Budgeting",
    "Event Planning",
    "Teaching",
    "Coaching",
    "Mentoring",
    "Public Relations",
    "Supply Chain Management",
    "Logistics",
    "Compliance",
    "Healthcare",
    "Human Resources",
    "Recruiting",
    "Training and Development",
    "Operations Management"
]

export const jobTag = [
    "Remote",
    "Full-Time",
    "Part-Time",
    "Contract",
    "Temporary",
    "Internship",
    "Freelance",
    "Entry Level",
    "Mid Level",
    "Senior Level",
    "Executive",
    "Marketing",
    "Sales",
    "Engineering",
    "Human Resources",
    "Finance",
    "IT",
    "Healthcare",
    "Education",
    "Customer Service",
    "Operations",
    "Project Management",
    "Administrative",
    "Creative",
    "Legal",
    "Manufacturing",
    "Real Estate",
    "Construction",
    "Hospitality",
    "Transportation",
    "Logistics",
    "Retail",
    "Telecommunications",
    "Media",
    "Non-Profit",
    "Government",
    "Energy",
    "Aerospace",
    "Agriculture",
    "Technology",
    "Pharmaceutical",
    "Biotechnology",
    "Environmental",
    "Consulting",
    "Research and Development",
    "Strategy",
    "Supply Chain",
    "Security",
    "Quality Assurance",
    "Compliance",
    "Event Planning",
    "Training and Development",
    "Business Development",
    "Product Management",
    "Data Science",
    "UX/UI Design",
    "Software Development",
    "Network Administration",
    "Database Management",
    "Technical Support"
]
